export async function calculateWaterfloodForecast(production, params) {
  try {
    const lengthForecast = production?.byFluid?.oil?.length - params.ti + 360;
    if (!lengthForecast > 0) return null;

    let oilForecast = [];
    let date = new Date(production?.byFluid?.oil?.filter(p => p.monthsOnline <= params.ti)?.slice(-1)?.[0]?.date);

    let cumVolP50 = production?.byFluid?.oil?.find(p => p.monthsOnline === params.ti)?.cumVolume;

    for (let i = 0; i < lengthForecast; i++) {
      const oilCut = calculateProduction('hyperbolic', params.qi, params.di, params.b, (i+1)); // calculate production using Arps equation
      const q = oilCut * params.maxFluidRate;

      const monthsOnline = params.ti + i;
      date = new Date(date.setMonth(date.getMonth() + 1));

      const oilCutP50 = oilCut * 100;
      const oilCutP10 = (oilCutP50 + (oilCutP50 * (0.25 * (i / lengthForecast))));
      const oilCutP90 = (oilCutP50 - (oilCutP50 * (0.2 * (i / lengthForecast))));
      
      const oilRateP10 = (q + (q * (0.25 * (i / lengthForecast))));
      const oilRateP90 = (q - (q * (0.2 * (i / lengthForecast))));
      
      oilForecast.push({
        monthsOnline,
        date,
        oilCut: { p10: oilCutP10, p50: oilCutP50, p90: oilCutP90 },
        volume: { p10: oilRateP10, p50: q, p90: oilRateP90 },
        cumVolume: { p10: 0, p50: 0, p90: 0 }
      });
    };

    // calculate cum oil
    oilForecast?.forEach((d,i) => {
      if (i === 0) {
        oilForecast[i].cumVolume.p10 = d.volume.p10 + cumVolP50;
        oilForecast[i].cumVolume.p50 = d.volume.p50 + cumVolP50;
        oilForecast[i].cumVolume.p90 = d.volume.p90 + cumVolP50;
      } else {
        oilForecast[i].cumVolume.p10 = oilForecast[i-1].cumVolume.p10 + d.volume.p10;
        oilForecast[i].cumVolume.p50 = oilForecast[i-1].cumVolume.p50 + d.volume.p50;
        oilForecast[i].cumVolume.p90 = oilForecast[i-1].cumVolume.p90 + d.volume.p90;
      };
    });

    // calculate eur
    const eur = calculateEur(oilForecast, production?.byFluid?.oil, params.cutoff, params.ti);

    return { oilForecast, eur };

  } catch (error) {
    console.log(error);
    return null;
  };
};

const calculateEur = (forecast, production, cutoff, ti) => {
  try {
    let eur = {
      p10: {
        monthsOnline: null,
        date: null,
        volume: null,
        cumVolume: null
      },
      p50: {
        monthsOnline: null,
        date: null,
        volume: null,
        cumVolume: null
      },
      p90: {
        monthsOnline: null,
        date: null,
        volume: null,
        cumVolume: null
      },
    };

    const cumVolToDate = production?.slice(-1)?.[0]?.cumVolume;

    ['p10', 'p50', 'p90'].forEach(prob => {
      let totalCumVol = cumVolToDate;

      for (let f of forecast) {
        if (f.volume?.[prob] <= cutoff) { 
          eur[prob].monthsOnline = f.monthsOnline;
          eur[prob].date = f.date;
          eur[prob].volume = f.volume[prob];
          eur[prob].cumVolume = totalCumVol;
          break;
        } else {
          totalCumVol += (f.volume?.[prob] || 0);
        };
      };

      if (!eur[prob]?.cumVolume) {
        const lastForecast = forecast?.slice(-1)?.[0];
        eur[prob].monthsOnline = lastForecast?.monthsOnline;
        eur[prob].date = lastForecast?.date;
        eur[prob].volume = lastForecast?.volume?.[prob];
        eur[prob].cumVolume = totalCumVol;
      };
    });
    // ['p10', 'p50', 'p90'].forEach(prob => {
    //   forecast.every((prod) => {
    //     if (prod?.oilRate?.[prob] <= cutoff && prod?.monthsOnline >= ti) { // only take values beyond Ti
    //       eur[prob].monthsOnline = prod.monthsOnline;
    //       eur[prob].date = prod.date;
    //       eur[prob].volume = prod.oilRate[prob];
    //       eur[prob].cumVolume = prod.cumVolume[prob];
    //       return false;
    //     };
    //     return true;
    //   });
    //   ['monthsOnline', 'date', 'volume', 'cumVolume'].forEach(param => {
    //     if (!eur[prob][param]) {
    //       if (param === 'volume' || param === 'cumVolume') {
    //         eur[prob][param] = Number((forecast?.[forecast?.length - 1]?.[param]?.[prob])?.toFixed(1));
    //       } else {
    //         eur[prob][param] = forecast?.[forecast?.length - 1]?.[param];
    //       };
    //     };
    //   });
    // });
    return eur;
  } catch (error) {
    console.log('Could not calculate EUR');
    console.log(error);
    return {};
  };
};

function calculateProduction (equation, qi, di, b, month) {
  let q = 0;
  if (equation === 'hyperbolic') {
    // q = parseFloat((qi / Math.pow((1.0 + b * di * month), (1.0 / b))));
    q = parseFloat(qi / Math.pow((1.0 + (Math.pow((1.0 - di), -b) - 1) * month), (1.0 / b)));
  } else if (equation === 'exponential') {
    q = parseFloat((qi * Math.exp(-di * month)));
  };
  return q;
};